import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

import {FuseProgressBarService} from '@fuse/components/progress-bar/progress-bar.service';

import {CancelApprovedRequestComponent} from '../cancel-approved-request';
import {ApprovalRequestApiService} from './approval-request-api.service';
import {ApprovalRequestStatus, ErrorDialogComponent, IManagementRequest} from '@appshared';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ManagementRequestService {
  private _confirmDialogRef: MatDialogRef<any>;
  constructor(
    private _matDialog: MatDialog,
    private _fuseProgressBarService: FuseProgressBarService,
    private _approvalRequestApiSrv: ApprovalRequestApiService,
    private _translate: TranslateService,
  ) { }

  cancel(request: IManagementRequest): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this._confirmDialogRef = this._matDialog.open(CancelApprovedRequestComponent, {
        width: '420px',
        disableClose: true,
      });
      this._confirmDialogRef.componentInstance.data = request;
      this._confirmDialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._fuseProgressBarService.show();
          this._confirmDialogRef = null;
          this._approvalRequestApiSrv.updateStatus([request.id], ApprovalRequestStatus.CANCELED, result).subscribe(
            res => {
              this._fuseProgressBarService.hide();
              resolve(true);
            },
            err => {
              this._fuseProgressBarService.hide();
              this._matDialog.open(ErrorDialogComponent, {
                disableClose: true,
              });
              reject();
            }
          );
        }
      });
    });
  }
}
